/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ComplianceListPaginationContainer_search$ref = any;
export type SearchType = "ADMITS" | "ATTENTION" | "BARRIER" | "DISCHARGE" | "ESCALATIONS" | "LOS_REVIEW" | "PATIENT" | "PROGRESSION" | "VARIANCE" | "VISIT" | "%future added value";
export type ComplianceListQueryVariables = {|
  first?: ?number,
  after?: ?string,
  type?: ?SearchType,
  query?: ?string,
|};
export type ComplianceListQueryResponse = {|
  +$fragmentRefs: ComplianceListPaginationContainer_search$ref
|};
export type ComplianceListQuery = {|
  variables: ComplianceListQueryVariables,
  response: ComplianceListQueryResponse,
|};
*/


/*
query ComplianceListQuery(
  $first: Int
  $after: String
  $type: SearchType
  $query: String
) {
  ...ComplianceListPaginationContainer_search_Fqyl5
}

fragment ComplianceListPaginationContainer_search_Fqyl5 on Query {
  viewer {
    beds(first: $first, after: $after, type: $type, query: $query) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
        totalCount
      }
      edges {
        bed: node {
          id
          name
          department {
            id
            exchangeName
            name
            type
            includedInLosCalculation
          }
          exchangeName
          status
          visit {
            id
            visitNumber
            patientProblem
            homeBedExchangeName
            admissionType
            anticipatedDischargeTime
            anticipatedDischargeUpdatedBy {
              userName
              firstName
              lastName
              id
            }
            targetDischargeTime
            bedRequestStatus
            decisionTime
            tlos
            currentDayOfStay
            admittingComplaint
            meta {
              timeElapsedSinceAdmission
              id
            }
            drgAttributes {
              code
              title
              level
              targetLos
              modifyTargetLos
              id
            }
            patient {
              id
              mrn
              age
              gender
              lastName
              middleInitial
              firstName
            }
            workingDischargeDisposition {
              id
              code
              value
            }
            dischargeVendor
            plan {
              id
              progressionIndicator
              toBeAdmitted
              milestones {
                id
              }
              appliedTemplates {
                id
                name
                removed
              }
              careTeamMembers {
                id
                name
                primary
                role {
                  id
                  code
                  value
                }
              }
            }
            anticipatedTransferTime
            anticipatedDischargeTimeAutoPopulated
            anticipatedTransferTimeAutoPopulated
          }
        }
        cursor
        node {
          __typename
          id
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  },
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "type"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "exchangeName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v12 = [
  (v6/*: any*/),
  (v11/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ComplianceListQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "FragmentSpread",
        "name": "ComplianceListPaginationContainer_search"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ComplianceListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "BedConnection",
            "kind": "LinkedField",
            "name": "beds",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPreviousPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startCursor",
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BedEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": "bed",
                    "args": null,
                    "concreteType": "Bed",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Department",
                        "kind": "LinkedField",
                        "name": "department",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v8/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "includedInLosCalculation",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Visit",
                        "kind": "LinkedField",
                        "name": "visit",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "visitNumber",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "patientProblem",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "homeBedExchangeName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "admissionType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "anticipatedDischargeTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AuditUser",
                            "kind": "LinkedField",
                            "name": "anticipatedDischargeUpdatedBy",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "userName",
                                "storageKey": null
                              },
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "targetDischargeTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bedRequestStatus",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "decisionTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tlos",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "currentDayOfStay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "admittingComplaint",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "VisitMeta",
                            "kind": "LinkedField",
                            "name": "meta",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "timeElapsedSinceAdmission",
                                "storageKey": null
                              },
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DrgAttributes",
                            "kind": "LinkedField",
                            "name": "drgAttributes",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "level",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "targetLos",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "modifyTargetLos",
                                "storageKey": null
                              },
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Patient",
                            "kind": "LinkedField",
                            "name": "patient",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "mrn",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "age",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "gender",
                                "storageKey": null
                              },
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "middleInitial",
                                "storageKey": null
                              },
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WorkingDischargeDispositionDTO",
                            "kind": "LinkedField",
                            "name": "workingDischargeDisposition",
                            "plural": false,
                            "selections": (v12/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dischargeVendor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Plan",
                            "kind": "LinkedField",
                            "name": "plan",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "progressionIndicator",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "toBeAdmitted",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Milestone",
                                "kind": "LinkedField",
                                "name": "milestones",
                                "plural": true,
                                "selections": [
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TemplateInfo",
                                "kind": "LinkedField",
                                "name": "appliedTemplates",
                                "plural": true,
                                "selections": [
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "removed",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CareTeamMember",
                                "kind": "LinkedField",
                                "name": "careTeamMembers",
                                "plural": true,
                                "selections": [
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "primary",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CodeTablePair",
                                    "kind": "LinkedField",
                                    "name": "role",
                                    "plural": false,
                                    "selections": (v12/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "anticipatedTransferTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "anticipatedDischargeTimeAutoPopulated",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "anticipatedTransferTimeAutoPopulated",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Bed",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v4/*: any*/),
            "filters": [
              "type",
              "query"
            ],
            "handle": "connection",
            "key": "ComplianceListPaginationContainer_beds",
            "kind": "LinkedHandle",
            "name": "beds"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fc5fddd9f49d4ec6a044169e760b2019",
    "id": null,
    "metadata": {},
    "name": "ComplianceListQuery",
    "operationKind": "query",
    "text": "query ComplianceListQuery(\n  $first: Int\n  $after: String\n  $type: SearchType\n  $query: String\n) {\n  ...ComplianceListPaginationContainer_search_Fqyl5\n}\n\nfragment ComplianceListPaginationContainer_search_Fqyl5 on Query {\n  viewer {\n    beds(first: $first, after: $after, type: $type, query: $query) {\n      totalCount\n      pageInfo {\n        endCursor\n        hasNextPage\n        hasPreviousPage\n        startCursor\n        totalCount\n      }\n      edges {\n        bed: node {\n          id\n          name\n          department {\n            id\n            exchangeName\n            name\n            type\n            includedInLosCalculation\n          }\n          exchangeName\n          status\n          visit {\n            id\n            visitNumber\n            patientProblem\n            homeBedExchangeName\n            admissionType\n            anticipatedDischargeTime\n            anticipatedDischargeUpdatedBy {\n              userName\n              firstName\n              lastName\n              id\n            }\n            targetDischargeTime\n            bedRequestStatus\n            decisionTime\n            tlos\n            currentDayOfStay\n            admittingComplaint\n            meta {\n              timeElapsedSinceAdmission\n              id\n            }\n            drgAttributes {\n              code\n              title\n              level\n              targetLos\n              modifyTargetLos\n              id\n            }\n            patient {\n              id\n              mrn\n              age\n              gender\n              lastName\n              middleInitial\n              firstName\n            }\n            workingDischargeDisposition {\n              id\n              code\n              value\n            }\n            dischargeVendor\n            plan {\n              id\n              progressionIndicator\n              toBeAdmitted\n              milestones {\n                id\n              }\n              appliedTemplates {\n                id\n                name\n                removed\n              }\n              careTeamMembers {\n                id\n                name\n                primary\n                role {\n                  id\n                  code\n                  value\n                }\n              }\n            }\n            anticipatedTransferTime\n            anticipatedDischargeTimeAutoPopulated\n            anticipatedTransferTimeAutoPopulated\n          }\n        }\n        cursor\n        node {\n          __typename\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '12de18614193d5b98352a362c69ef2ca';

module.exports = node;
